import axios from 'axios'
import { Buffer } from 'buffer'
import { env } from '../index.js'

let instance = null

class NexusAssetsApi {
  getAssets = async (msalInstance, accounts, baseURL, folder) => {
    let credentials = Buffer.from(
      `${env.basicAuthentication.gatekeeperUserName}:${env.basicAuthentication.gatekeeperPassword}`
    ).toString('base64')

    return await axios
      .get(`${baseURL}/api/nexusassets/all/${folder}`, {
        headers: { Authorization: `Basic ${credentials}` },
        timeout: 30000
      })
      .then(res => res.data)
  }

  uploadAsset = async (msalInstance, accounts, baseURL, folder, contentType, file) => {
    let credentials = Buffer.from(
      `${env.basicAuthentication.gatekeeperUserName}:${env.basicAuthentication.gatekeeperPassword}`
    ).toString('base64')

    return await axios({
      url: `${baseURL}/api/nexusassets/${folder}?contentType=${encodeURIComponent(contentType)}`,
      method: 'POST',
      data: file,
      headers: {
        'Content-Type': contentType,
        Authorization: `Basic ${credentials}`,
        timeout: 30000
      }
    })
  }

  deleteAsset = async (msalInstance, accounts, baseURL, folder, fileName) => {
    let credentials = Buffer.from(
      `${env.basicAuthentication.gatekeeperUserName}:${env.basicAuthentication.gatekeeperPassword}`
    ).toString('base64')

    return await axios
      .delete(`${baseURL}/api/nexusassets/${folder}/${fileName}`, {
        headers: { Authorization: `Basic ${credentials}` },
        timeout: 30000
      })
      .then(res => res.data)
  }
}

const getInstance = () => {
  if (instance == null) {
    instance = new NexusAssetsApi()
  }
  return instance
}

export default getInstance()
